import { Container } from "./styles";
import Yadhunadh from "../../assets/yadhunadh.webp";
import magento from "../../assets/magento.svg";
import shopify from "../../assets/shopify.svg";
import nextJSIcon from "../../assets/nextjs.png";
import htmlIcon from "../../assets/html-icon.svg";
import cssIcon from "../../assets/css-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import nodeIcon from "../../assets/node-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import typescriptIcon from "../../assets/typescript-icon.svg";
import vueIcon from "../../assets/vue-icon.svg";
import boostrapIcon from "../../assets/bootstrap-icon.svg";
import { Fade } from 'react-awesome-reveal';

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <Fade direction="left">
          <h2>Who Am I?</h2>
        </Fade>
        <Fade direction="left" delay={0.1 * 1000}>
          <p>
            Hi there! I'm Yadhunadh Chemmarassery, a skilled UI/fullstack developer with over 12 years of experience in web and application development. Throughout my career, I have successfully utilized a wide range of technologies including PHP, NodeJS, HTML5, JavaScript, TypeScript, ReactJS, Next.js, KnockoutJS, CSS3, TailwindCSS, MySQL, GraphQL, and various other frameworks and tools.
          </p>
        </Fade>
        <Fade direction="left" delay={0.2 * 1000} style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <p>
          During my time as a UI developer, I primarily concentrated on developing E-commerce websites. My focus was on utilizing ReactJS for frontend development, while also working extensively with Next.js, Node.js, Magento and Shopify. This approach allowed me to empower the companies to easily manage and update their websites, ensuring they remained current and user-friendly.</p>
        </Fade>
        <Fade direction="left" delay={0.3 * 1000}>
          <p>
          Additionally, I assist business owners in creating exceptionally designed websites that contribute to the enhancement of their sales and overall business growth and expansion.</p>
        </Fade>
        <Fade direction="left" delay={0.4 * 1000}>
          <h3>Here are my main skills:</h3>
        </Fade>
        <div className="hard-skills">
          <div className="hability">
            <Fade direction="up" delay={0.10 * 1000}>
              <img src={magento} alt="Magento" />
            </Fade>
          </div>
          <div className="hability">
            <Fade direction="up" delay={0.12 * 1000}>
              <img src={shopify} alt="shopify" />
            </Fade>
          </div>
          <div className="hability">
            <Fade direction="up" delay={0.13 * 1000}>
              <img src={reactIcon} alt="React" />
            </Fade>
          </div>
          <div className="hability">
            <Fade direction="up" delay={0.13 * 1000}>
              <img src={nextJSIcon} alt="Next.js" />
            </Fade>
          </div>
          <div className="hability">
            <Fade direction="up" delay={0.14 * 1000}>
              <img src={typescriptIcon} alt="Typescript" />
            </Fade>
          </div>
          <div className="hability">
            <Fade direction="up" delay={0.15 * 1000}>
              <img src={vueIcon} alt="Vue" />
            </Fade>
          </div>
          <div className="hability">
            <Fade direction="up" delay={0.16 * 1000}>
              <img src={nodeIcon} alt="Node" />
            </Fade>
          </div>
          <div className="hability">
            <Fade direction="up" delay={0.19 * 1000}>
              <img src={jsIcon} alt="JavaScript" />
            </Fade>
          </div>
          <div className="hability">
            <Fade direction="up" delay={0.17 * 1000}>
              <img src={htmlIcon} alt="Html" />
            </Fade>
          </div>
          <div className="hability">
            <Fade direction="up" delay={0.18 * 1000}>
              <img src={cssIcon} alt="Css" />
            </Fade>
          </div>
          <div className="hability">
            <Fade direction="up" delay={0.19 * 1000}>
              <img src={boostrapIcon} alt="bootstrap" />
            </Fade>
          </div>
          
        </div>
      </div>
      <div className="about-image">
        <Fade direction="right" delay={0.20 * 1000}>
          <img src={Yadhunadh} alt="Yadhunadh Chemmarassery" />
        </Fade>
      </div>
    </Container>
  )
}
